import {
	Component,
	AfterViewInit,
	Input,
	ViewChild,
	ElementRef,
	ViewEncapsulation,
	OnDestroy,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	EventEmitter,
	Output,
	HostBinding
} from "@angular/core";
import { IdService } from "../shared/services/id.service";

import { DomSanitizer } from "@angular/platform-browser";

@Component({
	selector: "rbc-card",
	templateUrl: "./card.component.html",
	encapsulation: ViewEncapsulation.None,
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent implements AfterViewInit, OnDestroy {
	@Input() id: string;
	@Input() scrollable: boolean;
	@Input() height: number;
	@Input() link: string;
	@Input() routerLink;
	@Input() linkLabel: string;
	@Input() target: string;
	@Input() flush: boolean;
	@Input() cardClass: string;
	@Input() cardStyle: string;
	@Input() tabbable: boolean;
	@Input() role: string;
	@Input() labelledBy: string;
	@Input() isModal = false;
	@HostBinding('class.rbc-card-shadow') @Input() shadow = true;
	@HostBinding('class.rbc-card') card = true;

	@HostBinding('class.rbc-card-hover') @Input() hoverable: boolean;

	get isLink() {
		return this.link ? true : false;
	}

	get isRouter(){
		return this.routerLink? true: false
	}

	@Output() cardClicked = new EventEmitter();

	@ViewChild("cardHeader", { static: false }) header: ElementRef;
	@ViewChild("cardFooter", { static: false }) footer: ElementRef;
	@ViewChild("body", { static: false }) body: ElementRef;
	@ViewChild("cardResults", { static: false }) cardResults: ElementRef;

	// @HostBinding('class.rbc-card') cardHostClass: boolean = true;

	headerFlag = true;
	footerFlag = true;

	constructor(private idService: IdService, private cdr: ChangeDetectorRef, private sanitizer: DomSanitizer) {
		this.id = idService.generate();
	}

	ngAfterViewInit() {
		if (this.header) {
			const headerCheck = this.header.nativeElement.children.length;
			const footerCheck = this.footer.nativeElement.children.length;
			if (!headerCheck || !footerCheck) {
				if (!headerCheck) {
					this.headerFlag = false;
				}
				if (!footerCheck) {
					this.footerFlag = false;
				}

				this.cdr.detectChanges();
			} else if (this.isModal || !footerCheck) {
				const modalFooterCheck = this.footer.nativeElement.children[0].children.length;
				if (!modalFooterCheck) {
					this.footerFlag = false;
				}

				this.cdr.detectChanges();
			}
		}
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	// sed to scroll the card programatically
	scrollBody(val) {
		this.cardResults.nativeElement.scrollTop = val;
	}

	bodyClassGen() {
		return {
			"rbc-card-flush": this.flush,
			"rbc-card-scrollable": this.scrollable
		};
	}

	cardClassGen() {
		const classes = {};
		// classes["rbc-card-hover"] = this.isLink || this.hoverable;
		classes["rbc-card-link"] = this.isLink;
		// classes["rbc-card-shadow"] = this.shadow;
		classes[this.cardClass] = this.cardClass;

		return classes;
	}

	heightGen() {
		return (this.height && typeof this.height !== "string") ? `${this.height}px` : this.height;
	}

	sanitize(url: string) {
		return this.sanitizer.bypassSecurityTrustUrl(url);
	}
}
